import styled, { keyframes } from "styled-components";

import { Link } from "react-router-dom";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;

  display: flex;
  /* align-items: center; */
  justify-content: center;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;


export const Content = styled.div`
  width: 80%;
  height: fit-content;
  margin-top: 40px;
  z-index: 1;

  border-radius: 10px;

  overflow: hidden;

  animation: ${fadeIn} 0.4s;

  > h1 {
    margin: 10px;
  }

  @media (max-width: 425px) {
    width: 98%;

    padding: 10px;
  }
`;

export const Card = styled.section`
  margin: 10px;
  padding: 10px;
  background-color: var(--white);
  margin-bottom: 30px;

  border-radius: 10px;
  box-shadow: 2px 2px 5px;
  border: 1px solid var(--gray);

  > label {
    margin-bottom: 2px;
    font-weight: bold;
  }

  > p {
    color: var(--gray);
    font-size: 25px;
    margin-bottom: 10px;

    @media (max-width: 425px) {
      font-size: 18px;
    }
  }
`;

export const LinkMenu = styled(Link)`
  color: var(--black);
  width: 100px;

  text-decoration: none;
  font-weight: bold;

  :hover {
    opacity: 0.8;
  }
  :active {
    opacity: 0.6;
  }
`;

export const Notificacao = styled.section`
  padding: 10px;
  margin-bottom: 5px;

  border-radius: 10px;
  background-color: #333;
  color: var(--white);

  display: flex;
  align-items: center;

  > p {
    flex: 1;

    cursor: pointer;

    :hover {
      opacity: 0.8;
    }

    :active {
      opacity: 0.4;
    }
  }

  > span {
    font-size: 30px;
    margin-left: 50px;

    cursor: pointer;

    :hover {
      opacity: 0.8;
    }

    :active {
      opacity: 0.4;
    }
  }
`;
